import {Subject} from 'rxjs';


export const auth:any = { member: null, token:null, authentication: false, userValidation:false, }
export const authSubject = new Subject();
export const loginModalSubject = new Subject();
export const loginMember: any = {};
export const sideMenuSubject = new Subject();
